import { render, staticRenderFns } from "./SquadbeyondConversionApiHistoryList.vue?vue&type=template&id=af38d9ea&scoped=true"
import script from "./SquadbeyondConversionApiHistoryList.vue?vue&type=script&lang=js"
export * from "./SquadbeyondConversionApiHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af38d9ea",
  null
  
)

export default component.exports